<template>
  <div>
    <nav-bar/>
    <sidebar-toggle-button ref="toggleSidebarArrow"></sidebar-toggle-button>
    <chat-page/>
    <ticket-button/>

    <!-- Sidebar -->
    <div class="sidebar bg-darkgrey navbar-inverse side-box-shadow" v-if="$store.state.isSidebarOpen">
      <ul class="nav flex-column">
        <li class="nav-item" :class="{'current': selectedStatus === 'pending'}">
          <a class="nav-link navbar-text pull-left" @click="onSidebarAccountClick(); selectedStatus = 'pending'">{{$t('Account.sidebar.pending')}} ({{getAccounts('pending').length}})</a>
        </li>
        <li class="nav-item" :class="{'current': selectedStatus === 'approved'}">
          <a class="nav-link navbar-text pull-left" @click="onSidebarAccountClick(); selectedStatus = 'approved'">{{$t('Account.sidebar.accepted')}} ({{getAccounts('approved').length}})</a>
        </li>
        <li class="nav-item" :class="{'current': selectedStatus === 'denied'}">
          <a class="nav-link navbar-text pull-left" @click="onSidebarAccountClick(); selectedStatus = 'denied'">{{$t('Account.sidebar.refused')}} ({{getAccounts('denied').length}})</a>
        </li>
      </ul>
    </div>

    <!-- DESKTOP -->
    <table-element
      :isShowFilter="true"
      :title="`${$t('Account.title_pending')}`"
      :fields="fieldsObj"
      :arrOfElement="filteredAccounts"
      :sortSpacing="0"
      :sortSpacingEnd="3"
      class="card mx-2 my-4"
      @updateFilterResults="updateFilterResults"
    >
      <template #header-actions>
      </template>

      <template #body-content-desktop="content">
        <!-- List of orders -->
        <tr v-for="(account, index) in content.results"
        class="table-element_hover text-center"
        :key="index">
          <td class="nowrap"><strong>{{account.name}}</strong></td>
          <td class="nowrap">{{account.address}} {{account.city}} {{account.province}}, {{account.postcode}} {{account.country}}</td>
          <td class="nowrap"><p class="table-fix-width">{{account.email}}</p></td>
          <td class="nowrap">{{account.phone}}</td>
          <td v-if="account.fax !== ' ' && account.fax !== ''" class="nowrap">{{account.fax}}</td>
          <td v-else class="nowrap"><strong><i>X</i></strong></td>
          <td class="nowrap"><strong>{{translateStatus(account.status)}}</strong></td>
          <td class="nowrap"><button class="btn btn-kne-orange" @click="editAccount(account, accountStatus.edit)">{{$t('Account.button_edit')}}</button></td>
          <td>
            <button v-show="account.status !== accountStatus.approved" class="btn btn-kne-orange" @click="editAccount(account, accountStatus.approved)">
              <i class="fa fa-check" aria-hidden="true"></i>
            </button>
          </td>
          <td>
            <button v-show="account.status !== accountStatus.denied" class="btn btn-kne-orange" @click="editAccount(account, accountStatus.denied)">
              <i class="fa fa-times" aria-hidden="true"></i>
            </button>
          </td>
        </tr>
      </template>

      <template #body-content-mobile="content">
        <!-- List of orders -->
        <div v-for="(account, index) in content.results"
        class="card my-3 mx-2"
        :key="index">
          <div class="card-header m-2">
            <h4>{{account.name}}</h4>
            <h6 class="nowrap"><p class="table-fix-width">{{account.email}}</p></h6>
          </div>

          <div class="m-2">
            <h6 class="nowrap">{{account.address}} {{account.city}} {{account.province}}, {{account.postcode}} {{account.country}}</h6>
            <h6 class="nowrap"><p class="table-fix-width">{{account.email}}</p></h6>
            <h6 class="nowrap">{{account.phone}}</h6>
            <h6 v-if="account.fax !== ' ' && account.fax !== ''" class="nowrap">{{account.fax}}</h6>
            <h6 v-else class="nowrap"><strong><i>X</i></strong></h6>
            <h6 class="nowrap"><strong>{{translateStatus(account.status)}}</strong></h6>
          </div>

          <div class="m-2" id="action">
            <h6 class="nowrap"><button class="btn btn-kne-orange" @click="isEditAccount = true; editAccount(account, account.edit)">{{$t('Account.button_edit')}}</button></h6>
            <h6 v-if="account.status !== accountStatus.approved">
              <button class="btn btn-kne-orange" @click="editAccount(account, accountStatus.approved)">
                <i class="fa fa-check" aria-hidden="true"></i>
              </button>
            </h6>
            <h6 v-if="account.status !== accountStatus.denied">
              <button class="btn btn-kne-orange" @click="editAccount(account, accountStatus.denied)">
                <i class="fa fa-times" aria-hidden="true"></i>
              </button>
            </h6>
          </div>
        </div>
      </template>
    </table-element>

    <loading-render v-if="isLoading" />

    <modal
      :title="$t('Account.modal.title_pending_edit')"
      v-if="isEditAccount"
      @close-request="isEditAccount = false; onEditModalClose()"
      closableBackdrop
      closable>
      <pending-account-form
        ref="transporterAccountFormJS"
        @closeEditModal="isEditAccount = false"
        :edittedAccount="modifiedAccount"
        :transporterList="transporters"
        :isEditMode="true"
        :newStatus="newStatus"
        :companyUID="companyUID">
      </pending-account-form>
    </modal>
  </div>
</template>

<script>
import { db } from '../../firebase'

import SidebarToggleButton from '../module/interface-components/sidebarToggleButton.vue'
import RegularInput from '../module/basic-components/regularInput.vue'
import Navbar from '../module/interface-components/NavBar.vue'
import ChatPage from '../module/interface-components/ChatPage.vue'
import TicketButton from '../module/interface-components/TicketButton.vue'
import Modal from '../module/interface-components/Modal.vue'
import PendingAccountForm from '../module/special-components/account-admin-components/PendingAccountForm.vue'
import TableElement from '../module/special-components/Table-component/Table-Element.vue'
import LoadingRender from '../module/special-components/Other-components/LoadingRender.vue'

export default {
  name: 'PendingAccounts',

  components: {
    RegularInput,
    Navbar,
    ChatPage,
    TicketButton,
    Modal,
    PendingAccountForm,
    TableElement,
    LoadingRender,
    SidebarToggleButton
  },

  data () {
    return {
      selectedStatus: '',
      transporters: [],
      pendingAccounts: [],
      filterResults: [],
      paginate: ['filterResults'],
      fields: {
        '.key': '',
        address: '',
        email: '',
        fax: '',
        status: '',
        name: '',
        phone: ''
      },
      searchHistory: [],
      searchType: '',
      searchText: '',
      historyTypeTag: '',
      isCreateAccount: false,
      isEditAccount: false,
      modifiedAccount: {}, /** Sent as props to @component pending-account-form */
      newStatus: '', /** Sent as props to @component pending-account-form */
      accountStatus: {
        approved: 'Approved',
        pending: 'Pending',
        denied: 'Denied',
        edit: 'Edit'
      },
      fieldsObj: [
       {
         text: this.$t('Account.name'),
         type: 'name',
         value: ''
       },
       {
         text: this.$t('Account.address'),
         type: 'address',
         value: ''
       },
       {
         text: this.$t('Account.email'),
         type: 'email',
         value: ''
       },
       {
         text: this.$t('Account.phone'),
         type: 'phone',
         value: ''
       },
       {
         text: this.$t('Account.fax'),
         type: 'fax',
         value: ''
       },
       {
         text: this.$t('Account.status.account_status'),
         type: 'status',
         value: ''
       }
      ]
    }
  },

  created () {
    this.isLoading = true
    this.isScreenSmall = window.innerWidth < 800

    this.$bindAsArray('pendingAccounts', db.ref('users/pending-creation').orderByChild('transporterUid').equalTo(this.companyUID), null, () => {
      this.isLoading = false
    })

    // this.$bindAsArray('pendingAccounts', db.ref('users/dev'), null, () => {
    //   this.filteredSearchMethod()
    //   this.isLoading = false
    // })

    this.$bindAsArray('transporters', db.ref('users/transporters'), null, () => {})
  },

  methods: {
    onSidebarAccountClick () {
      if (!this.selectedStatus) return this.pendingAccounts

      const accounts = this.getAccounts()

      return accounts
    },

    getAccounts (type) {
      const accounts = [...this.pendingAccounts]
      const currentStatus = type || this.selectedStatus
      let returnedAccounts = []

      accounts.forEach(account => {
        const isAccountSameStatus = currentStatus === account.status.toLowerCase() // If the status of the ticket is the same as the status option

        if (isAccountSameStatus) returnedAccounts.push(account)
      })

      return returnedAccounts
    },

    updateFilterResults (sortResults) {
      this.filterResults = sortResults
    },

    editAccount (account, status) {
      this.modifiedAccount = account
      this.isEditAccount = true
      this.newStatus = status
    },

    onEditModalClose () {
      this.$refs.transporterAccountFormJS.restoreTransporterLinkData()
    },

    translateStatus (status) {
      switch (status.toLowerCase()) {
        case this.accountStatus.denied.toLowerCase():
          return `${this.$t('Account.status.account_denied')}`

        case this.accountStatus.pending.toLowerCase():
          return `${this.$t('Account.status.account_pending')}`

        case this.accountStatus.approved.toLowerCase():
          return `${this.$t('Account.status.account_approved')}`

        default:
          console.log('Error unknown status', status)
          return ''
      }
    }
  },

  computed: {
    companyUID () {
      return this.$store.state.authorization.company
    },

    filteredAccounts () {
      return this.onSidebarAccountClick()
    }
  }
}
</script>

<style scoped>
  .current{
    border-left: 3px solid #f7941e;
  }
  .fa-check {
    font-size: 0.75rem
  }
</style>
